/**
 * Generates label text for a multi-select trigger.
 * - No selection → fallback.
 * - One item → item text.
 * - Multiple → "First + N".
 */
export function formatSelectedLabel(selection, fallbackLabel) {
  if (!selection?.length) return fallbackLabel;
  if (selection.length === 1) return selection[0].text || fallbackLabel;
  return `${selection[0].text} + ${selection.length - 1}`;
}

export function getIsAllItemsSelected(draftSelection, allItems) {
  if (!allItems?.length) return false;

  const selectedIds = new Set(draftSelection?.map((entry) => entry.id) ?? []);

  return allItems.every((item) => selectedIds.has(item.id));
}

/**
 * True when some — but not all — items are selected, so the "all" row can be
 * rendered as indeterminate.
 */
export function getIsPartiallySelected(draftSelection, allItems) {
  if (!draftSelection?.length || !allItems?.length) return false;
  if (getIsAllItemsSelected(draftSelection, allItems)) return false;

  const selectableIds = new Set(allItems.map((item) => item.id));

  return draftSelection.some((entry) => selectableIds.has(entry.id));
}
